export default __webpack_public_path__ + "static/media/competitive-sentiment.png";